import { BotItem } from '@/models/bot';
import { IBotStats, IBotFilters, IBotConditions } from '@/types';

export const useBotStore = defineStore('bot', () => {
    const items = ref<BotItem[]>([]);
    const total = ref<number>(0);
    const loading = ref<boolean>(false);
    const isExtraFiltersDisplayed = ref<boolean>(false);
    const filters = reactive<IBotFilters>({
        name: '',
        status: null,
        date: null,
    });

    const conditionsFormSettings = reactive<Record<string, boolean>>({});

    const stats = reactive<IBotStats>({
        activeBotCount: 0,
        avgOdds: '0',
        balance: '0',
        inactiveBotCount: 0,
        settledBetCount: 0,
        settledStakeSum: '0',
        totalBotCount: 0,
        unsettledBetCount: 0,
        unsettledBetSum: '0',
        unsettledStakeSum: '0',
        winRate: '0',
        yield: '0',
        yieldFlat: '0',
    });

    const conditions = reactive<IBotConditions>({
        isLive: 0,
        isLeague: 0,
        isLiveStats: 0,
        isMarketMargin: 0,
        isDball: 0,
    });

    // function afterCreated(data: { row: any; stats?: Partial<Stats> }) {
    //     const newList = [...list.value, data.row];
    //     setList(newList);
    //     if (data.stats) {
    //         setStats(data.stats);
    //     }
    // }

    return {
        items,
        total,
        stats,
        loading,
        filters,
        isExtraFiltersDisplayed,
        conditionsFormSettings,
        conditions,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useBotStore, import.meta.hot));
}
